// Aumonline's OWN costume — private to the Aumonline account only (never
// offered at signup). Same software/IT pipeline, but the "Type" list is
// Aumonline's real products plus Mutual Funds (the owner tracks those
// enquiries here too). Keeping it separate means generic software
// companies who sign up never see Aumonline's product names.

import { SOFTWARE_COSTUME } from "./software";

export const AUMONLINE_COSTUME = {
  ...SOFTWARE_COSTUME,
  costumeId: "aumonline_v1",
  enquiryTypes: [
    "Kreta",
    "Apoopika",
    "Jigyasa",
    "Mutual Funds",
    "More than one product",
    "Other",
  ],
};
